module.exports = __webpack_public_path__ + "assets/img/photo_default_icon.7560493f.png";